import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/cdl-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const CDLLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function CDLLogo(props, ref) {
    const logoProps = getLogoProps(props, {
      primary: { light: '#13235e', dark: '#3D74B2' },
      secondary: { light: '#999999', dark: '#eeeeee' },
    })

    return <Logo {...logoProps} ref={ref} />
  },
)
